import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  baseScroll: {
    marginTop: pixelDimensions(3),
    marginHorizontal: pixelDimensions(2),
    marginBottom: pixelDimensions(16),
  },
  viewMessageLeths: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  viewMessageUser: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    alignSelf: 'flex-end',
  },
  cardBoxMessage: {
    backgroundColor: Colors.white,
    padding: pixelDimensions(3),
    margin: pixelDimensions(2),
    width: pixelDimensions(60),
    flexWrap: 'wrap',
  },
  nameUserLeths: {
    color: appColors.darkBlue,
    fontWeight: '700',
  },
  textBoxMessage: {
    flexWrap: 'wrap',
  },
  boxSendMessage: {
    backgroundColor: Colors.grey300,
    padding: pixelDimensions(2),
    height: pixelDimensions(15),
    flexDirection: 'row',
    alignItems: 'center',
    position: 'absolute',
    right: 0,
    left: 0,
    bottom: 0,
  },
  inputSendMessage: {
    flex: 1,
    backgroundColor: appColors.white,
    alignItems: 'center',
    paddingLeft: pixelDimensions(2),
    marginHorizontal: pixelDimensions(2),
    height: pixelDimensions(10),
    borderRadius: pixelDimensions(2),
  },
  buttonSend: {
    backgroundColor: appColors.green,
    padding: pixelDimensions(2),
    borderRadius: pixelDimensions(7),
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default styles;
